module.exports = __webpack_public_path__ + "img/passport_seria_new.a04017d7.png";